/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_StyleInputs */

const en_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption Style...`)
};

const fr_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style de sous-titre...`)
};

const de_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschriftenstil...`)
};

const it_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile didascalia...`)
};

const ru_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль подписи...`)
};

const es_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de subtítulo...`)
};

const zh_cn2_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题样式……`)
};

const ja_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションスタイル...`)
};

const hi_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन शैली...`)
};

const pt_pt2_caption_style = /** @type {(inputs: Caption_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo da legenda...`)
};

/**
* | output |
* | --- |
* | "Caption Style..." |
*
* @param {Caption_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style = /** @type {((inputs?: Caption_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_style(inputs)
	if (locale === "de") return de_caption_style(inputs)
	if (locale === "it") return it_caption_style(inputs)
	if (locale === "ru") return ru_caption_style(inputs)
	if (locale === "es") return es_caption_style(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_style(inputs)
	if (locale === "ja") return ja_caption_style(inputs)
	if (locale === "hi") return hi_caption_style(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_style(inputs)
	return en_caption_style(inputs)
});